import HelpCircle from '@/assets/icons/HelpCircle.svg';
import Info from '@/assets/icons/Info.svg';
import { IconButton } from '@/components/IconButton';
import { Tooltip } from '@/components/Tooltip';

interface HelpTipProps {
  label: string;
  tip: string;
  variant: 'help' | 'info';
}

export const HelpTip = ({ label, tip, variant }: HelpTipProps) => (
  <Tooltip tip={tip}>
    <IconButton
      icon={variant === 'help' ? <HelpCircle /> : <Info />}
      isRound={true}
      label={label}
      width={18}
    />
  </Tooltip>
);
